import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {
  InputTextArea,
  Input,
  Icon,
  Link,
  Color,
} from '@brokerbay/elements-web';
import { ShowingConfigData } from '../types';

type AlarmInstructionsProps = {
  showingsConfig: ShowingConfigData;
  setShowingsConfig: React.Dispatch<React.SetStateAction<ShowingConfigData>>;
  forceClose: boolean;
};

const AlarmInstructions: React.FC<AlarmInstructionsProps> = ({
  showingsConfig,
  setShowingsConfig,
  forceClose,
}) => {
  const [showAlarmInstructions, setShowAlarmInstructions] = useState(false);

  useEffect(() => {
    if (forceClose) {
      setShowAlarmInstructions(false);
    }
  }, [forceClose]);

  useEffect(() => {
    setShowAlarmInstructions(
      Boolean(showingsConfig.instructions.alarm?.code) ||
        Boolean(showingsConfig.instructions.alarm?.details),
    );
  }, [
    showingsConfig.instructions.alarm?.code,
    showingsConfig.instructions.alarm?.details,
  ]);

  const toggleAlarm = () => {
    if (showAlarmInstructions) {
      setShowingsConfig(prev => ({
        ...prev,
        instructions: {
          ...prev.instructions,
          alarm: {
            code: '',
            details: '',
          },
        },
      }));
      setShowAlarmInstructions(false);
    } else {
      setShowAlarmInstructions(true);
    }
  };

  const updateAlarmCode = (value: string) => {
    setShowingsConfig(prev => ({
      ...prev,
      instructions: {
        ...prev.instructions,
        alarm: {
          ...(prev.instructions.alarm || {
            code: '',
            details: '',
          }),
          code: value,
        },
      },
    }));
  };

  const updateAlarmDetails = (value: string) => {
    setShowingsConfig(prev => ({
      ...prev,
      instructions: {
        ...prev.instructions,
        alarm: {
          ...(prev.instructions.alarm || {
            code: '',
            details: '',
          }),
          details: value,
        },
      },
    }));
  };

  return (
    <div>
      <Link
        dataCy="showing-notification-toggle-alarm"
        onClick={toggleAlarm}
        size="large"
        thickness="bold"
      >
        {showAlarmInstructions ? (
          <>
            <Icon icon="minusOutlined" color="primary" size={16} /> Remove alarm
          </>
        ) : (
          <>
            <Icon icon="plusCircleOutlined" color="primary" size={16} /> Add
            alarm
          </>
        )}
      </Link>
      {showAlarmInstructions && (
        <PaddedInnerSpace>
          <ShortInputContainer>
            <Input
              label="Alarm code"
              dataCy="showing-notification-alarm-code"
              value={showingsConfig.instructions.alarm?.code || ''}
              onChange={updateAlarmCode}
            />
          </ShortInputContainer>

          <InputTextArea
            label="Alarm instructions"
            dataCy="showing-notification-other-alarm-instructions"
            value={showingsConfig.instructions.alarm?.details || ''}
            onChange={updateAlarmDetails}
            minHeight={100}
          />
        </PaddedInnerSpace>
      )}
    </div>
  );
};

const PaddedInnerSpace = styled.div`
  margin-top: 8px;
  padding: 16px 24px;
  background-color: ${Color.LIGHTER_GREY};
  width: 100%;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ShortInputContainer = styled.div`
  width: 60%;
`;

export default AlarmInstructions;
